<template>
    <div class="pagePart pagePart--no-top-offset">
        <div class="pagePart-in view-mobile-nosides">
            <div class="calculator">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CalculationContainer',
    }
</script>



// WEBPACK FOOTER //
// src/components/calculation/CalculationContainer.vue